<template>
  <div class="document">
    <!-- <img
      v-if="document.raw.type.includes('image')"
      :src="imageURL"
    > -->
    <div class="document__row">
      <span
        @click="document?.id?.value ? downloadFile(document.id.value) : {}"
        >{{ documentName }}</span
      >
      <Button
        v-if="allowRemove"
        class="document__row--button"
        hasLeftIcon
        iconName="delete"
        buttonColor="transparent"
        @click="allowRemove ? deleteFile() : null"
        :class="{ 'is-visible': visibleDeleteIcon }"
      />
    </div>
  </div>
</template>

<script>
import Button from 'Elements/Button/Button';
import { getController } from '@/controllers/request';

export default {
  components: { Button },
  props: {
    index: Number,
    document: {
      type: Object
    },
    detailsText: String,
    // documentLink: String,
    documentName: String,
    allowRemove: {
      type: Boolean,
      default: false
    },
    visibleDeleteIcon: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    deleteFile() {
      this.$emit('delete-file', this.document, this.index);
    },
    s2ab(s) {
      let buf = new ArrayBuffer(s.length);
      let view = new Uint8Array(buf);
      for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;

      return buf;
    },
    async downloadFile(id) {
      try {
        const resp = await getController({
          url: `/index.php?entryPoint=download_spa&id=${id}&type=Notes`
        });
        if (resp.data) {
          const data = { ...resp.data };
          let blob = new Blob([this.s2ab(atob(data.fileData))], {
            type: data.fileType
          });
          let url = URL.createObjectURL(blob);
          let a = document.createElement('a');

          document.body.appendChild(a);
          a.style = 'display: none';
          a.href = url;
          a.download = data.fileName;
          a.click();
          a.remove();
          URL.revokeObjectURL(url);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.document {
  display: flex;
  flex-direction: row;
  gap: 8px;
  border-radius: 4px;
  padding: 8px 12px;
  align-items: center;
  background: $grey8;
  border-radius: 4px;

  img {
    width: 24px;
    height: 24px;
    border-radius: 2px;
  }

  &:hover {
    background: $grey12;
  }

  &:not(:last-child) {
    margin-bottom: 4px;
  }

  &__row {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    span {
      text-overflow: ellipsis;
      text-align: left;
      white-space: nowrap;
      text-decoration: none !important;
      overflow: hidden;
      font-size: 14px;
      line-height: 20px;
      width: 100%;
      cursor: pointer;
    }

    &--button {
      padding: 0 !important;
      width: 24px;
    }
  }
}
</style>
